import { fadeStyling } from "@made-people/blueprint-topbar/blueprint";

fadeStyling.main.override({
  slots: {
    wrapper:
      "relative px-component-spacing-sm md:px-component-spacing-lg lg:px-component-spacing-3xl bg-surface-1",
    fade: "flex justify-center items-center overflow-hidden transition-all",
    item: "flex items-center justify-center py-2 w-full",
    label: "text-body-xs lg:text-body-sm w-full text-center truncate",
  },
});
